import { createApp } from 'vue';
import JpgToAvifConverter from '../Components/JpgToAvifConverter.vue';

const root = document.getElementById('jpg-to-avif-converter');
if (root) {
  createApp(JpgToAvifConverter).mount('#jpg-to-avif-converter');
}
